import {Checkbox} from 'primereact/checkbox'
import {forwardRef, useCallback, useImperativeHandle, useState} from 'react'
import FlexBox from '../layout/FlexBox'

const MultiCheckboxUtils = forwardRef(
    ({defaultValue = [], checkboxList = [], layout = 'grid'}, ref) => {
        useImperativeHandle(ref, () => ({
            value: handleGetData(),
        }))
        const handleGetData = () => {
            return checkedItems
        }
        const [checkedItems, setCheckedItems] = useState(defaultValue)

        const onItemChange = useCallback(
            e => {
                let _checkItems = [...checkedItems]

                if (e.checked) {
                    _checkItems.push(e.value)
                } else {
                    for (let i = 0; i < _checkItems.length; i++) {
                        const selectedItem = _checkItems[i]

                        if (selectedItem.value === e.value.value) {
                            _checkItems.splice(i, 1)
                            break
                        }
                    }
                }
                setCheckedItems(_checkItems)
            },
            [checkedItems],
        )

        const checkboxRender = checkboxList => {
            return checkboxList?.map(item => (
                <div
                    key={item.value}
                    className="md:col-6 col-12 field-checkbox px-0">
                    <Checkbox
                        name={item.label}
                        value={item}
                        onChange={onItemChange}
                        checked={checkedItems.some(e => item.value === e.value)}
                    />
                    <label htmlFor={item.label}>{item.label}</label>
                </div>
            ))
        }
        return layout === 'grid' ? (
            <div>{checkboxRender(checkboxList)}</div>
        ) : layout === 'flex' ? (
            <div
                className={
                    'flex align-items-center justify-content-start flex-wrap'
                }>
                {checkboxList?.map(item => (
                    <div key={item.value} className="field-checkbox m-2">
                        <Checkbox
                            className=""
                            name={item.label}
                            value={item}
                            onChange={onItemChange}
                            checked={checkedItems.some(
                                e => item.value === e.value,
                            )}
                        />
                        <label htmlFor={item.label}>{item.label}</label>
                    </div>
                ))}
            </div>
        ) : (
            <FlexBox className={'col-6'}>
                {checkboxList?.map(item => (
                    <div
                        key={item.value}
                        className="col-2 justify-content-center field-checkbox">
                        <Checkbox
                            className=""
                            name={item.label}
                            value={item}
                            onChange={onItemChange}
                            checked={checkedItems.some(
                                e => item.value === e.value,
                            )}
                        />
                    </div>
                ))}
            </FlexBox>
        )
    },
)

export default MultiCheckboxUtils
